import { z } from "zod";
import { ScheduleLifecycleVerb } from "@common/types/domains/accounting/schedule";
import { applicationIdsSchema } from "./scheduleApplication.schema";
import { scheduleApplicationListItemSchema } from "./scheduleApplicationList.schema";
import { scheduleApplicationBulkFailureSchema } from "./scheduleBulkFailure.schema";
import { scheduleStopSettlementSchema } from "./scheduleLifecycle.schema";

export const SCHEDULE_LIFECYCLE_BULK_VERBS = [
    ScheduleLifecycleVerb.pause,
    ScheduleLifecycleVerb.resume,
    ScheduleLifecycleVerb.cancel,
] as const;

export const scheduleLifecycleBulkVerbSchema = z.enum(
    SCHEDULE_LIFECYCLE_BULK_VERBS,
);

export type ScheduleLifecycleBulkVerb = z.infer<
    typeof scheduleLifecycleBulkVerbSchema
>;

const SETTLEMENT_ONLY_ON_STOP_MESSAGE = "Only Stop can settle the balance";

export const scheduleLifecycleBulkBodySchema = z
    .object({
        entityId: z.number().int().positive(),
        verb: scheduleLifecycleBulkVerbSchema,
        applicationIds: applicationIdsSchema,
        effectiveDate: z.string().date().optional(),
        settlement: scheduleStopSettlementSchema.optional(),
    })
    .superRefine((body, ctx) => {
        if (body.settlement && body.verb !== ScheduleLifecycleVerb.cancel) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["settlement"],
                message: SETTLEMENT_ONLY_ON_STOP_MESSAGE,
            });
        }
    });

export const scheduleLifecycleBulkResponseSchema = z.object({
    updated: z.array(
        z.object({
            applicationId: z.string().uuid(),
            application: scheduleApplicationListItemSchema,
        }),
    ),
    failed: z.array(scheduleApplicationBulkFailureSchema),
});

export type ScheduleLifecycleBulkBody = z.infer<
    typeof scheduleLifecycleBulkBodySchema
>;

export type ScheduleLifecycleBulkResponse = z.infer<
    typeof scheduleLifecycleBulkResponseSchema
>;
